import { Component, Vue, Prop, Provide, Watch } from 'vue-property-decorator';
import { TemedSliderItem } from '../../components/TemedSliderItem';
import { IProvider, ITemedRequest, ITemedResponse, INamed, IPoint, IDoctor, ILocation } from '../../models';

import * as DataService from '../../services/DataService';
import { AppService } from '../../services/AppService';

import * as DistanceUtils from '../../utils/DistanceUtils';

import * as geoUtils from '../../utils/GeoUtils';
import { EventBus, TEMED_WIDGET_EVENTS } from '../../services/EventBus';
import { TemedDoctorDetails } from '../TemedDoctorDetails';

import './MostRatedSliderWidget.scss';

@Component({
  template: require('./MostRatedSliderWidget.html'),
  components:{
    'temed-slider-item': TemedSliderItem,
    'temed-doctor-details': TemedDoctorDetails
  }
})
export class MostRatedSliderWidget extends Vue {

  @Prop({ default: '' })
  medcat: string;

  @Prop({ default: 'doctors' })
  type: string;

  @Prop({ default: 'See full doctor\'s profile' })
  linkText: string;

  @Prop({ default: 'https://www.temed.com/' })
  url: string;

  @Prop({ default: 6 })
  count: number;

  @Prop({ default: false })
  useState: boolean;

  items: IProvider[] = [];

  itemsFull: IDoctor[] = [];

  currentItem: IDoctor = null;

  userState = DataService.DEFAULT_STATE;

  linkUrl = '';

  userLocation: ILocation;

  requestPosition = true;

  mapInited = false;

  protected appService: AppService;


  mounted () {
    this.appService = AppService.getInstance();
    this.userLocation = this.appService.get('userLocation');
    this.userState = this.userLocation && this.userLocation.state ? this.userLocation.state : DataService.DEFAULT_STATE;

    geoUtils.handlePermission((result) => {
      if(result.state === 'denied'){
        this.initData();
      }
      if(result.state !== 'prompt'){
        this.requestPosition = false;
      }else{
        this.requestPosition = true;
      }
    });
    EventBus.$on(TEMED_WIDGET_EVENTS.GEO_LOCATION_CHANGED, () => {
      this.appService.getUserLocation()
        .then(location => {
          this.userLocation = location;
          this.userState = this.userLocation.state;
          console.log(TEMED_WIDGET_EVENTS.GEO_LOCATION_CHANGED);
          this.initData();
        }).catch(e => {
          console.log(e);
        });
    });
    this.initData();
  }


  initData(){
    this.linkUrl = `${this.url}doctors?state=${this.userState}`;
    const request: ITemedRequest ={
      query: '*',
      query_type: this.type,
      page: 1,
      per_page: this.count,
      medcat_name: this.medcat,
      state: this.useState ? this.userState : ''
    };
    DataService.searchProviders(request).then(response => {
      const providers = response.data.providers;
      this.items = providers.length > this.count ? providers.slice(0, this.count) : providers;
      this.loadFullData();
    }).catch(e => {
      console.log(e);
    });
  }

  loadFullData(){
    const itemsLoaded: IDoctor[] = [];

    this.items.map((item, index) => {

      DataService.getDoctorInfo(item.slug).then(response => {
        itemsLoaded.push(response.data);
        if(itemsLoaded.length === this.items.length){
          itemsLoaded.sort((a,b) => b.rating - a.rating)
          this.itemsFull = itemsLoaded;
          this.itemsFull[0].most_rated = true;
          this.currentItem = this.itemsFull[0];
        }
      });

    });
  }

  nextItem(){
    const first = this.itemsFull.splice(0, 1);
    this.itemsFull.push(first[0]);
    this.currentItem = this.itemsFull[0];
  }

  prevItem(){
    const last = this.itemsFull.pop();
    this.itemsFull.unshift(last);
    this.currentItem = this.itemsFull[0];
  }

  onItemClick(item){
    const itemIndex = this.itemsFull.indexOf(item);
    console.log(itemIndex);
    if(itemIndex !== -1 && itemIndex > 0){
      const firstPart = this.itemsFull.splice(0, itemIndex);
      this.itemsFull = this.itemsFull.concat(firstPart);
      this.currentItem = this.itemsFull[0];
    }
  }
}
